export default "__VITE_ASSET__LhORZ6Ij__"